(function () {
  const PROP_NAME = "Delivery option";
  const UI_STORE_KEY = "trq_dm_ui_mode";
  const APPLY_DELAY_MS = 80;

  const DRAWER_SECTION_CANDIDATES = ["cart-drawer", "mini-cart", "cart-drawer-items"];

  const SS_SEEN_NM_KEYS = "trq_seen_nm_keys";
  const SS_BATCH_MODE_PREFIX = "trq_nm_mode_";
  const SS_LAST_CART_SNAPSHOT = "trq_cart_snapshot";

  const LS_ELIGIBLE_PRODUCTS = "trq_preorder_eligible_product_ids"; // JSON array

  function qs(sel) { return document.querySelector(sel); }

  function getUIValue() {
    const el = qs('.preorder-toggle input[name="__delivery_mode_ui"]:checked');
    return el ? el.value : (localStorage.getItem(UI_STORE_KEY) || "sofort");
  }

  function uiToLabel(v) {
    return v === "preorder" ? "Preorder" : "Immediate";
  }

  function setHiddenProperty(label) {
    const hidden = qs("#delivery_mode_prop");
    if (hidden) hidden.value = label;
  }

  function readEligibleSet() {
    try {
      const arr = JSON.parse(localStorage.getItem(LS_ELIGIBLE_PRODUCTS) || "[]");
      return new Set(arr.map(String));
    } catch (_) {
      return new Set();
    }
  }

  function persistEligibleFromWindow() {
    const ids = (window.__trq_preorder_product_ids || []).map(String);
    if (!ids.length) return;

    const set = readEligibleSet();
    for (const id of ids) set.add(id);
    localStorage.setItem(LS_ELIGIBLE_PRODUCTS, JSON.stringify([...set]));
  }

  // ---------------- EasyWholesale: grau/disable nach custom.on_hand ----------------
  function getPdpProductIdForOnHandMap() {
    const map = window.__trq_on_hand_map || {};
    const pids = Object.keys(map);
    return pids.length ? String(pids[0]) : null;
  }

  function getOnHandMapForPdp() {
    const pid = getPdpProductIdForOnHandMap();
    if (!pid) return null;
    const map = window.__trq_on_hand_map || {};
    return map[pid] || null; // { "variantId": number }
  }

  function extractVariantIdFromUpdatesName(name) {
    const m = String(name || "").match(/updates\[(\d+)\]/);
    return m ? m[1] : null;
  }

  function setEasyWholesaleRowDisabled(qtyInput, disabled) {
    const row = qtyInput.closest(".nm-easywholesale-item");
    if (!row) return;

    const btnPlus = row.querySelector(".nm-easywholesale-qty-increase");
    const btnMinus = row.querySelector(".nm-easywholesale-qty-decrease");

    if (disabled) {
      row.classList.add("trq-ew-disabled");

      // Menge auf 0 setzen (damit nicht add-to-cart)
      if (String(qtyInput.value) !== "0") {
        qtyInput.value = "0";
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      }

      if (btnPlus) btnPlus.setAttribute("aria-disabled", "true");
      if (btnMinus) btnMinus.setAttribute("aria-disabled", "true");
    } else {
      row.classList.remove("trq-ew-disabled");
      if (btnPlus) btnPlus.removeAttribute("aria-disabled");
      if (btnMinus) btnMinus.removeAttribute("aria-disabled");
    }
  }

  function applyMatrixImmediateAvailability() {
    // nur auf PDPs mit Toggle
    if (!qs(".preorder-toggle")) return;

    const mode = getUIValue();
    const isImmediate = mode === "sofort";

    const onHandMap = getOnHandMapForPdp();
    if (!onHandMap) return;

    // EasyWholesale qty inputs
    const qtyInputs = Array.from(document.querySelectorAll('input.nm-easywholesale-qty[name^="updates["]'));
    if (!qtyInputs.length) return;

    for (const inp of qtyInputs) {
      const vid = extractVariantIdFromUpdatesName(inp.getAttribute("name"));
      if (!vid) continue;

      const qty = Number(onHandMap[String(vid)] ?? 0);

      // Regel:
      // Immediate => qty<=0 grau/disable
      // Preorder  => alles aktiv
      setEasyWholesaleRowDisabled(inp, isImmediate && qty <= 0);
    }
  }

  // PDP init
  function initPdpIfPresent() {
    persistEligibleFromWindow();

    const wrap = qs(".preorder-toggle");
    if (!wrap) return;

    const stored = localStorage.getItem(UI_STORE_KEY);
    if (stored === "preorder" || stored === "sofort") {
      const el = qs(`.preorder-toggle input[name="__delivery_mode_ui"][value="${stored}"]`);
      if (el) el.checked = true;
    }

    setHiddenProperty(uiToLabel(getUIValue()));
    applyMatrixImmediateAvailability();
  }

  document.addEventListener("change", (e) => {
    if (!e.target.matches('.preorder-toggle input[name="__delivery_mode_ui"]')) return;
    const v = getUIValue();
    localStorage.setItem(UI_STORE_KEY, v);
    setHiddenProperty(uiToLabel(v));
    applyMatrixImmediateAvailability();
  });

  // EW rendert/filtered dynamisch -> Observer
  (function observeEasyWholesale() {
    const obs = new MutationObserver(() => {
      try { applyMatrixImmediateAvailability(); } catch (_) {}
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  })();

  // --------- snapshot helpers ----------
  function takeSnapshotFromCart(cart) {
    const keyQty = {};
    const keyVar = {};
    for (const it of (cart.items || [])) {
      keyQty[it.key] = Number(it.quantity || 0);
      keyVar[it.key] = String(it.variant_id);
    }
    sessionStorage.setItem(SS_LAST_CART_SNAPSHOT, JSON.stringify({ keyQty, keyVar }));
  }

  function getSnapshot() {
    try {
      return JSON.parse(sessionStorage.getItem(SS_LAST_CART_SNAPSHOT) || "{}");
    } catch (_) {
      return {};
    }
  }

  // --------- EasyWholesale nm_wh parsing ----------
  function parseNmWhValue(v) {
    try {
      const arr = JSON.parse(v);
      return Array.isArray(arr) ? arr : [];
    } catch (_) {
      return [];
    }
  }

  function getNewNmKeys(attrsObj) {
    const seen = new Set(JSON.parse(sessionStorage.getItem(SS_SEEN_NM_KEYS) || "[]"));
    const newKeys = [];

    for (const k of Object.keys(attrsObj || {})) {
      if (!k.startsWith("nm_wh_items_")) continue;
      if (seen.has(k)) continue;
      seen.add(k);
      newKeys.push(k);
    }

    sessionStorage.setItem(SS_SEEN_NM_KEYS, JSON.stringify([...seen]));
    return newKeys;
  }

  function nmKeyToVariantQty(attrsObj, nmKey) {
    const out = new Map();
    const raw = (attrsObj && attrsObj[nmKey]) || "";
    const items = parseNmWhValue(raw);
    for (const it of items) {
      const vid = String(it && (it.id || it.variant_id) || "");
      const qty = Number(it && it.quantity || 0);
      if (!vid || !qty) continue;
      out.set(vid, (out.get(vid) || 0) + qty);
    }
    return out;
  }

  // --------- Drawer refresh ----------
  async function refreshDrawerSection() {
    const drawerEl = document.querySelector("#cart-drawer, .cart-drawer, [data-cart-drawer]");
    if (!drawerEl) return false;

    for (const sectionId of DRAWER_SECTION_CANDIDATES) {
      try {
        const res = await fetch(`/cart?section_id=${encodeURIComponent(sectionId)}`, { credentials: "same-origin" });
        if (res.ok) {
          const html = await res.text();
          const tmp = document.createElement("div");
          tmp.innerHTML = html;
          const newDrawer =
            tmp.querySelector("#cart-drawer") ||
            tmp.querySelector(".cart-drawer") ||
            tmp.querySelector("[data-cart-drawer]");
          if (newDrawer) {
            drawerEl.innerHTML = newDrawer.innerHTML;
            return true;
          }
        }
      } catch (_) {}

      try {
        const res = await fetch(`/?sections=${encodeURIComponent(sectionId)}`, { credentials: "same-origin" });
        if (!res.ok) continue;
        const json = await res.json();
        const sectionHtml = json && json[sectionId];
        if (!sectionHtml) continue;

        const tmp = document.createElement("div");
        tmp.innerHTML = sectionHtml;
        const newDrawer =
          tmp.querySelector("#cart-drawer") ||
          tmp.querySelector(".cart-drawer") ||
          tmp.querySelector("[data-cart-drawer]");
        if (newDrawer) {
          drawerEl.innerHTML = newDrawer.innerHTML;
          return true;
        }
      } catch (_) {}
    }
    return false;
  }

  // --------- core: apply props to new/increased EW lines ----------
  let applying = false;

  async function applyBatchToCartLines(nmKey, attrsObj) {
    const eligible = readEligibleSet();
    if (!eligible.size) return;

    const mode = sessionStorage.getItem(SS_BATCH_MODE_PREFIX + nmKey) || "sofort";
    const wantedLabel = uiToLabel(mode);

    const want = nmKeyToVariantQty(attrsObj, nmKey);
    if (want.size === 0) return;

    const before = getSnapshot();
    const beforeQty = before.keyQty || {};

    const cart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
    const items = cart.items || [];

    const targets = [];
    for (const it of items) {
      const vid = String(it.variant_id);
      if (!want.has(vid)) continue;

      const pid = String(it.product_id);
      if (!eligible.has(pid)) continue;

      const curProp = (it.properties && it.properties[PROP_NAME]) || "";
      if (curProp) continue;

      const prevQ = Number(beforeQty[it.key] || 0);
      const nowQ = Number(it.quantity || 0);
      const isNewOrIncreased = (!beforeQty[it.key]) || (nowQ > prevQ);

      if (isNewOrIncreased) targets.push(it);
    }

    if (targets.length === 0) {
      for (const it of items) {
        const vid = String(it.variant_id);
        if (!want.has(vid)) continue;

        const pid = String(it.product_id);
        if (!eligible.has(pid)) continue;

        const curProp = (it.properties && it.properties[PROP_NAME]) || "";
        if (curProp) continue;

        targets.push(it);
      }
    }

    for (const it of targets) {
      const newProps = Object.assign({}, it.properties || {}, { [PROP_NAME]: wantedLabel });
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          id: it.key,
          quantity: Number(it.quantity || 0), // Mengen-Fix
          properties: newProps
        })
      });
    }

    const cart2 = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
    takeSnapshotFromCart(cart2);
    await refreshDrawerSection();
  }

  async function applyAllPendingBatches(attrsObj, newNmKeys) {
    if (applying) return;
    applying = true;
    try {
      if (!sessionStorage.getItem(SS_LAST_CART_SNAPSHOT)) {
        const cart0 = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
        takeSnapshotFromCart(cart0);
      }
      for (const nmKey of newNmKeys) {
        await applyBatchToCartLines(nmKey, attrsObj);
      }
    } finally {
      applying = false;
    }
  }

  let t = null;
  function scheduleDrawerRefreshOnly() {
    clearTimeout(t);
    t = setTimeout(() => refreshDrawerSection(), APPLY_DELAY_MS);
  }

  const origFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const res = await origFetch.call(this, input, init);

    try {
      if (url.includes("/cart/update") && init && init.body && typeof init.body === "string") {
        let data = null;
        try { data = JSON.parse(init.body); } catch (_) {}
        const attrsObj = data && data.attributes;
        if (attrsObj) {
          const newNmKeys = getNewNmKeys(attrsObj);
          if (newNmKeys.length) {
            const mode = getUIValue();
            for (const k of newNmKeys) sessionStorage.setItem(SS_BATCH_MODE_PREFIX + k, mode);
            await applyAllPendingBatches(attrsObj, newNmKeys);
          }
        }
      }

      if (url.includes("/cart/add") || url.includes("/cart/update")) {
        scheduleDrawerRefreshOnly();
      }
    } catch (_) {}

    return res;
  };

  (function () {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__trq_url = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      try {
        const url = String(this.__trq_url || "");
        if (url.includes("/cart/add") || url.includes("/cart/update")) {
          this.addEventListener("loadend", () => {
            try { scheduleDrawerRefreshOnly(); } catch (_) {}
          });
        }
      } catch (_) {}
      return origSend.apply(this, arguments);
    };
  })();

  async function boot() {
    initPdpIfPresent();

    try {
      const cart0 = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
      takeSnapshotFromCart(cart0);
    } catch (_) {}

    // EW rendert oft delayed
    setTimeout(() => { try { applyMatrixImmediateAvailability(); } catch (_) {} }, 250);
    setTimeout(() => { try { applyMatrixImmediateAvailability(); } catch (_) {} }, 900);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();